import mirror from 'keymirror';

export const actionTypes = mirror({
  FLAG_TOGGLE_ERROR: null,
  FLAG_TOGGLE_SUCCESS: null,
  FLAG_SET: null,
});

const flagToggleSuccess = name => ({
  type: actionTypes.FLAG_TOGGLE_SUCCESS,
  name,
});

const flagToggleError = error => ({
  type: actionTypes.FLAG_TOGGLE_ERROR,
  error,
});

export const flagSet = ({ name, value }) => ({
  type: actionTypes.FLAG_SET,
  name,
  value,
});

export const toggleFeatureFlag = name => async dispatch => {
  try {
    dispatch(flagToggleSuccess(name));
  } catch (err) {
    dispatch(flagToggleError(err));
  }
};
